export const checkGooglePayAvailability = (): boolean => {
  const { userAgent } = window.navigator

  return (
    (/windows|macintosh/i.test(userAgent) && /chrome/i.test(userAgent)) ||
    /android/i.test(userAgent)
  )
}
